import { FC } from 'react';
import Rating from '@mui/material/Rating';
import Star from '@mui/icons-material/Star';

interface Props {
  stars?: number;
  maxStars?: number;
}

const Stars: FC<Props> = ({ stars = 0, maxStars = 5 }) => (
  <Rating
    value={Math.max(0, Math.min(stars, maxStars))}
    max={maxStars}
    readOnly
    size="small"
    getLabelText={value => `${value} out of ${maxStars} stars`}
    // The design uses filled muted stars for the empty slots, not outlines
    emptyIcon={<Star fontSize="inherit" />}
    sx={{
      '& .MuiRating-iconFilled': { color: 'staticPages.star' },
      '& .MuiRating-iconEmpty': { color: 'staticPages.starMuted' },
    }}
  />
);

export default Stars;
